module.exports = __webpack_public_path__ + "img/w1.1b55ccc0.png";